import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import { Dropdown, ToggleButton } from '@commons/utils/styledLibraryComponents';

import { Container, InfoText, ToggleContainer } from './styledComponents';

export const ENUM_B2B_CATALOGS_UPDATE_MODE = {
  ADD: 'add',
  REMOVE: 'remove',
};

// Platforms can have dozens of clients: cap the panel height so it does not overflow the modal
const CLIENTS_DROPDOWN_LIST_STYLE = { maxHeight: '200px' };

export const getB2bCatalogsUpdateModeChoices = () => [
  {
    key: ENUM_B2B_CATALOGS_UPDATE_MODE.ADD,
    name: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_MANAGE_OPTION_ADD'),
  },
  {
    key: ENUM_B2B_CATALOGS_UPDATE_MODE.REMOVE,
    name: i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_MANAGE_OPTION_REMOVE'),
  },
];

/**
 * Content of the "Gérer les catalogues client" modal (bulk add / remove of the selected
 * products to external client catalogs): a required multi-select of external clients and an
 * add (default) / remove toggle with a mode-specific information text.
 */
const ManageB2bCatalogsModal = (props) => {
  const { clients, selectedClients, setSelectedClients, selectedMode, setSelectedMode } = props;

  const isAddMode = selectedMode.key === ENUM_B2B_CATALOGS_UPDATE_MODE.ADD;

  return (
    <Container>
      <Dropdown
        customDropdownListStyle={CLIENTS_DROPDOWN_LIST_STYLE}
        customStyle={{ height: 'auto' }}
        iconSrc={
          selectedClients.length
            ? '/images/inpulse/briefcase-black-small.svg'
            : '/images/inpulse/briefcase-dmgrey-small.svg'
        }
        isUniqueSelection={false}
        items={clients}
        label={`${i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_MANAGE_CLIENTS_LABEL')} :`}
        placeholder={i18next.t('ADMIN.PRODUCTS.B2B_CATALOGS_MANAGE_CLIENTS_PLACEHOLDER')}
        selectedItems={selectedClients}
        isRequired
        onSelectionChange={setSelectedClients}
      />
      <ToggleContainer>
        <ToggleButton
          choices={getB2bCatalogsUpdateModeChoices()}
          customStyle={{ flex: 1 }}
          selectedChoice={selectedMode}
          setSelectedChoice={setSelectedMode}
        />
      </ToggleContainer>
      <InfoText>
        {i18next.t(
          isAddMode
            ? 'ADMIN.PRODUCTS.B2B_CATALOGS_MANAGE_ADD_INFO'
            : 'ADMIN.PRODUCTS.B2B_CATALOGS_MANAGE_REMOVE_INFO',
        )}
      </InfoText>
    </Container>
  );
};

ManageB2bCatalogsModal.propTypes = {
  clients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  selectedClients: PropTypes.array.isRequired,
  setSelectedClients: PropTypes.func.isRequired,
  selectedMode: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  setSelectedMode: PropTypes.func.isRequired,
};

export default ManageB2bCatalogsModal;
